module.exports = __webpack_public_path__ + "static/media/Ø2_4.4c53119f.png";